<template>
  <div>
    <b-form-group
      :id="$id('applicationPromoHeadlineFieldset')"
      label-cols="2"
      label="Title"
      label-class="pt-0"
      :label-for="$id('applicationPromoHeadline')">
      <template
        v-if="isInsider"
        #description>
        Title of the item (appears on the Android webview header only)
      </template>
      <b-form-input
        :id="$id('applicationPromoHeadline')"
        :value="title"
        name="title"
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoIosUrlFieldset')"
      label-cols="2"
      label="iOS URL"
      label-class="pt-0"
      :label-for="$id('applicationPromoIosUrl')"
      description="App Store Url">
      <b-form-input
        :id="$id('applicationPromoIosUrl')"
        :value="iosUrl"
        name="iosUrl"
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoAndroidUrlFieldset')"
      label-cols="2"
      label="Android URL"
      label-class="pt-0"
      :label-for="$id('applicationPromoAndroidUrl')"
      description="Play Store Url">
      <b-form-input
        :id="$id('applicationPromoAndroidUrl')"
        :value="androidUrl"
        name="androidUrl"
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoIosPackageFieldset')"
      label-cols="2"
      label="iOS Package"
      label-class="pt-0"
      :label-for="$id('applicationPromoIosPackage')"
      description="iOS package link">
      <b-form-input
        :id="$id('applicationPromoIosPackage')"
        :value="iosPackage"
        name="iosPackage"
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoAndroidPackageFieldset')"
      label-cols="2"
      label="Android Package"
      label-class="pt-0"
      :label-for="$id('applicationPromoAndroidPackage')"
      description="Android package link">
      <b-form-input
        :id="$id('applicationPromoAndroidPackage')"
        :value="androidPackage"
        name="androidPackage"
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoIntentFieldset')"
      label-cols="2"
      label="Intent"
      label-class="pt-0"
      :label-for="$id('applicationPromoIntent')"
      description="Android Intent Url">
      <b-form-input
        :id="$id('applicationPromoIntent')"
        :value="intent"
        name="intent"
        @input.native="emitFieldUpdate" />
    </b-form-group>

    <b-form-group
      v-if="!shouldHideImageField"
      :id="$id('applicationPromoImageFieldset')"
      label-cols="2"
      label="Image"
      label-class="pt-0"
      :label-for="$id('applicationPromoImageUpload')"
      description="The image attached to the app item">
      <b-input-group>
        <b-form-input
          :id="$id('applicationPromoImageUpload')"
          :value="imageUrl"
          type="url"
          trim
          name="imageUrl"
          @input.native="emitFieldUpdate" />
        <b-input-group-append>
          <b-btn
            variant="outline-primary"
            @click.prevent="$refs.assetUploadModal.show()">
            <i class="fas fa-plus" />
          </b-btn>
        </b-input-group-append>
      </b-input-group>
      <template
        v-if="!isInsider"
        #description>
        NOTE: Images do not display for More From items on Android devices
      </template>
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoPlatformsFieldset')"
      label-cols="2"
      label="Platforms"
      label-class="pt-0"
      description="The platform(s) this short content should appear on">
      <b-form-checkbox-group
        v-model="platforms"
        :options="[{text: 'iOS', value: 'ios'}, {text: 'Android', value: 'android'}]"
        switches
        stacked
        name="platforms[]"
        @change="emitFieldUpdate({target: {name: 'platforms', value: $event}})" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoDevicesFieldset')"
      label-cols="2"
      label="Devices"
      label-class="pt-0"
      description="The device(s) this short content should appear on">
      <b-form-checkbox-group
        v-model="devices"
        :options="[{text: 'Phone', value: 'phone'}, {text: 'Tablet', value: 'tablet'}]"
        switches
        stacked
        name="devices[]"
        @change="emitFieldUpdate({target: {name: 'devices', value: $event}})" />
    </b-form-group>

    <b-form-group
      :id="$id('applicationPromoPlatformsFieldset')"
      label-cols="2"
      label="Locales"
      label-class="pt-0"
      description="The locale(s) this short content should appear on">
      <b-form-checkbox-group
        v-model="locales"
        :options="[{text: 'English', value: 'en'}, {text: 'Spanish', value: 'es'}, {text: 'Japanese', value: 'ja'}]"
        switches
        stacked
        name="locales[]"
        @change="emitFieldUpdate({target: {name: 'locales', value: $event}})" />
    </b-form-group>

    <b-modal
      :id="$id('asset-upload')"
      ref="assetUploadModal"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        v-if="useCloudinary"
        :post-action="`https://api.cloudinary.com/v1_1/${CLOUDINARY_ACCOUNT}/image/upload`"
        :existing-files="[]"
        :without-auth-header="true"
        :cloudinary="{}"
        :constraint="constraint"
        @asset-selected-response="onAssetSelect"
        @cancel="$refs.assetUploadModal.hide()" />
      <asset-upload
        v-else
        post-action="/api/client-content/v1/files/static/application-promo"
        :existing-files="[]"
        :process-image-cuts="true"
        :constraint="constraint"
        @asset-selected-response="onAssetSelect"
        @cancel="$refs.assetUploadModal.hide()" />
    </b-modal>
  </div>
</template>

<script>
  import AssetUpload from '@/components/AssetUpload'

  export default {
    name: 'ApplicationPromo',
    components: {
      AssetUpload,
    },
    props: {
      id: {
        type: String,
        default: null,
      },
      title: {
        type: String,
        default: null,
      },
      iosUrl: {
        type: String,
        default: null,
      },
      androidUrl: {
        type: String,
        default: null,
      },
      iosPackage: {
        type: String,
        default: null,
      },
      androidPackage: {
        type: String,
        default: null,
      },
      intent: {
        type: String,
        default: null,
      },
      imageUrl: {
        type: String,
        default: null,
      },
      hbImages: {
        type: Object,
        default: null,
      },
      platforms: {
        type: Array,
        default: () => [],
      },
      devices: {
        type: Array,
        default: () => [],
      },
      locales: {
        type: Array,
        default: () => [],
      },
      cloudinary: {
        type: Boolean,
        default: false,
      },
      isInsider: {
        type: Boolean,
        default: false,
      },
      constraint: {
        type: Object,
        required: true,
      },
    },
    computed: {
      CLOUDINARY_ACCOUNT() {
        return process.env.VUE_APP_CLOUDINARY_ACCOUNT
      },
      useCloudinary() {
        // a little bit of a hack to dynamically support cloudinary or asset uploads
        // more menu images need to use asset manager for the various asset cuts
        // mashup can use cloudinary
        return this.cloudinary || this.imageUrl.includes("cloudinary") || this.imageUrl.includes("img.mlbstatic")
      },
      shouldHideImageField() {
        // We don't want to expose the image field for "More From" Android-only items.
        return !this.isInsider && this.platforms.length === 1 && this.platforms[0] === "android"
      },
    },
    methods: {
      onAssetSelect(response) {
        this.$refs.assetUploadModal.hide()

        if (response.url) {
          this.emitFieldUpdates([
            {
              target: {
                name: 'imageUrl',
                value: encodeURI(response.url),
              },
            },
            {
              target: {
                name: 'imagePublicId',
                value: response.public_id,
              },
            },
          ])
        } else {
          console.warn('Ignoring invalid asset selection')
        }
      },
      emitFieldUpdate(event, truthy, falsy) {
        const value = (() => {
          if (event.target.type === 'checkbox') {
            return event.target.checked ? truthy : falsy
          }

          return event.target.value
        })()

        this.$emit("field-update", {
          id: this.id,
          field: event.target.name,
          value,
        })
      },
      emitFieldUpdates(events) {
        const emitFieldUpdate = this.emitFieldUpdate

        events.forEach((event) => emitFieldUpdate(event))
      },
    },
  }
</script>

<style scoped>

</style>
